import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';

const apiUrl = environment.apiUrl;

@Injectable({
  providedIn: 'root'
})
export class OrderConfirmationService {
  constructor(private http: HttpClient) {}

  /**
   * Download PDF Auftragsbestätigung aus Sevdesk für Kunden (mit Magic Token)
   */
  downloadOrderConfirmationPdf(bookingId: string, token: string): void {
    const url = `${apiUrl}/api/bookings/${bookingId}/order-confirmation/sevdesk?token=${token}`;
    this.downloadFile(url, `Auftragsbestaetigung_${bookingId}.pdf`);
  }

  /**
   * Download PDF Auftragsbestätigung aus Sevdesk für Admin (mit JWT Auth)
   */
  downloadOrderConfirmationPdfAdmin(bookingId: string): void {
    const url = `${apiUrl}/api/bookings/${bookingId}/order-confirmation/sevdesk/admin`;
    this.downloadFile(url, `Auftragsbestaetigung_${bookingId}.pdf`);
  }

  /**
   * Öffne HTML-Vorschau für Kunden (fallback, alt)
   */
  previewOrderConfirmation(bookingId: string, token: string): void {
    const url = `${apiUrl}/api/bookings/${bookingId}/order-confirmation/html?token=${token}`;
    window.open(url, '_blank');
  }

  /**
   * Öffne HTML-Vorschau für Admin (fallback, alt)
   */
  previewOrderConfirmationAdmin(bookingId: string): void {
    const url = `${apiUrl}/api/bookings/${bookingId}/order-confirmation/html/admin`;
    window.open(url, '_blank');
  }

  /**
   * Hole HTML-Inhalt als String (für In-Page-Rendering)
   */
  getOrderConfirmationHtml(bookingId: string, token: string) {
    const url = `${apiUrl}/api/bookings/${bookingId}/order-confirmation/html?token=${token}`;
    return this.http.get(url, { responseType: 'text' });
  }

  /**
   * Helper: Datei herunterladen
   */
  private downloadFile(url: string, filename: string): void {
    this.http.get(url, { responseType: 'blob' }).subscribe({
      next: (blob) => {
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = filename;
        link.click();
        URL.revokeObjectURL(objectUrl);
      },
      error: (error) => {
        console.error('Fehler beim Download:', error);
      }
    });
  }
}
